export default {"src":"/_next/static/media/GumDisease.e14dea81.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};